import { render } from "./ForgotBanner.vue?vue&type=template&id=0992790b"
import script from "./ForgotBanner.vue?vue&type=script&lang=js"
export * from "./ForgotBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__